import { render } from "./FooterComponent.vue?vue&type=template&id=375a2f80"
const script = {}

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__